// lib/api/client.ts
import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_URL || "http://localhost:8080",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor per token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
const formDataClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_URL || "http://localhost:8080",
  timeout: 10000,
});
export default apiClient;
export { formDataClient };
